module.exports = function() {
  return new Worker(__webpack_public_path__ + "975a2ff94c1603798950.worker.js");
};